<template>
  <AppDialog
    :open="visible"
    @close="visible = false"
    title="Passwort zurücksetzen"
    classes="reset-password-dialog"
  >
    <ResetPasswordForm @submit="handleSubmit" />
  </AppDialog>
</template>

<script>
import AppDialog from "@/components/Dialog/AppDialog";
import ResetPasswordForm from "@/components/Forms/ResetPasswordForm";
import { errorHandler } from "@/router/utils";

export default {
  name: "ResetPasswordDialog",
  components: {
    ResetPasswordForm,
    AppDialog,
  },
  data() {
    return {
      visible: true,
    };
  },
  methods: {
    handleSubmit() {
      this.visible = false;
      this.$nextTick(() => this.$router.push("/login").catch(errorHandler));
    },
  },
};
</script>

<style>
.reset-password-dialog {
  @screen lg {
    min-width: 30%;
  }
}
</style>
